import { useState } from 'react';
import useNotification from '~/hooks/use-notification';
import api from '~/lib/api';

function useCountriesService() {
  const [file, setFile] = useState();
  const [loading, setLoading] = useState(false);
  const { addNotification } = useNotification();

  async function uploadFile() {
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append('data', file);
      await api.post(`/countries/countries-list`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      addNotification({
        type: 'success',
        message: 'Countries list uploaded successfully',
      });
    } catch (_e) {
      addNotification({
        type: 'error',
        message: `Countries list upload failed`,
      });
    }
    setLoading(false);
  }

  return {
    file,
    loading,
    setFile,
    uploadFile,
  };
}

export default useCountriesService;
